/* ============================================================
   SHADOWZ — theme.js
   Bez zależności. Każdy blok = jeden moduł.
   ============================================================ */
(function () {
  'use strict';

  var qs = function (s, c) { return (c || document).querySelector(s); };
  var qsa = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var T = (window.theme && window.theme.strings) || {};
  var ROUTES = (window.theme && window.theme.routes) || {};

  /* ---------- TOAST ---------- */
  var toastTimer = null;
  function toast(text) {
    var el = qs('#toast');
    if (!el) return;
    el.textContent = text;
    el.classList.add('is-on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.classList.remove('is-on'); }, 2600);
  }

  /* ---------- 01 MENU MOBILNE ---------- */
  function initMenu() {
    var burger = qs('#burger');
    var menu = qs('#menu');
    if (!burger || !menu) return;

    function close() {
      menu.hidden = true;
      burger.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('is-locked');
    }

    burger.addEventListener('click', function () {
      if (burger.getAttribute('aria-expanded') === 'true') { close(); return; }
      menu.hidden = false;
      burger.setAttribute('aria-expanded', 'true');
    });

    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }

  /* ---------- 02 ODLICZANIE DO DROPU ---------- */
  function initCountdown() {
    qsa('[data-countdown]').forEach(function (box) {
      var target = new Date(box.getAttribute('data-date')).getTime();
      if (isNaN(target)) return;

      var units = qsa('[data-unit]', box);
      var label = qs('[data-drop-date]', box.parentNode);
      var pad = function (n) { return n < 10 ? '0' + n : String(n); };

      function render() {
        var diff = Math.max(0, target - Date.now());
        var vals = {
          days: pad(Math.floor(diff / 86400000)),
          hours: pad(Math.floor((diff % 86400000) / 3600000)),
          minutes: pad(Math.floor((diff % 3600000) / 60000)),
          seconds: pad(Math.floor((diff % 60000) / 1000))
        };
        units.forEach(function (u) {
          var v = vals[u.getAttribute('data-unit')];
          if (u.textContent !== v) u.textContent = v;
        });
        if (diff === 0) {
          if (label && T.dropLive) label.textContent = T.dropLive;
          clearInterval(timer);
        }
      }

      render();
      var timer = setInterval(render, 1000);
    });
  }

  /* ---------- 03 FAQ ---------- */
  function initFaq() {
    qsa('.acc__trigger').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.acc__item');
        var open = btn.getAttribute('aria-expanded') === 'true';

        qsa('.acc__item.is-open').forEach(function (other) {
          if (other !== item) {
            other.classList.remove('is-open');
            qs('.acc__trigger', other).setAttribute('aria-expanded', 'false');
          }
        });

        btn.setAttribute('aria-expanded', String(!open));
        item.classList.toggle('is-open', !open);
      });
    });
  }

  /* ---------- 04 WYBÓR ROZMIARU ---------- */
  function initSizes() {
    qsa('[data-sizes], [data-variant-picker]').forEach(function (group) {
      var scope = group.closest('.card') || group.closest('.detail__info') || document;

      qsa('.size', group).forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (btn.classList.contains('is-sold')) {
            toast((T.sizeSoldOut || 'Rozmiar wyprzedany') + ' — ' + btn.getAttribute('data-size'));
            return;
          }

          qsa('.size', group).forEach(function (b) {
            b.classList.remove('is-active');
            if (b.hasAttribute('role')) b.setAttribute('aria-checked', 'false');
          });
          btn.classList.add('is-active');
          if (btn.hasAttribute('role')) btn.setAttribute('aria-checked', 'true');

          var input = qs('[data-variant-input]', scope);
          var id = btn.getAttribute('data-variant-id');
          if (input && id) input.value = id;

          var price = btn.getAttribute('data-price');
          var priceEl = qs('[data-price-value]', scope);
          if (price && priceEl) priceEl.textContent = price;

          var addBtn = qs('[data-add-to-cart]', scope);
          if (addBtn) addBtn.disabled = false;

          if (id && window.history && window.location.pathname.indexOf('/products/') > -1) {
            var url = new URL(window.location.href);
            url.searchParams.set('variant', id);
            window.history.replaceState({}, '', url.toString());
          }
        });
      });
    });
  }

  /* ---------- 05 GALERIA PRODUKTU ---------- */
  function initGallery() {
    var main = qs('#ProductImage');
    if (!main) return;

    qsa('[data-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        qsa('[data-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
        main.src = thumb.getAttribute('data-full');
        var srcset = thumb.getAttribute('data-srcset');
        if (srcset) main.srcset = srcset;
      });
    });
  }

  /* ---------- 06 KOSZYK (AJAX Cart API) ---------- */
  function updateCartCount(count) {
    var el = qs('#cartCount');
    if (!el) return;
    el.textContent = count;
    el.classList.toggle('is-on', count > 0);
  }

  function initAddToCart() {
    qsa('form[data-quick-add], form.product-form').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        var btn = qs('[data-add-to-cart]', form);
        var input = qs('[data-variant-input]', form) || qs('[name="id"]', form);
        if (!btn || !input) return;

        // brak wybranego rozmiaru na karcie produktu w siatce
        if (btn.hasAttribute('data-require-size')) {
          var card = form.closest('.card');
          if (card && !qs('.size.is-active', card)) {
            e.preventDefault();
            toast(T.chooseSize || 'Wybierz rozmiar.');
            return;
          }
        }

        if (!window.fetch) return; // bez fetch: zwykły POST do /cart/add
        e.preventDefault();

        var label = qs('[data-add-text]', btn);
        var original = label ? label.textContent : '';
        btn.disabled = true;
        btn.classList.add('is-loading');

        fetch(ROUTES.cart_add || '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(input.value), quantity: 1 }] })
        })
          .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
          .then(function (res) {
            if (!res.ok) throw new Error(res.data.description || res.data.message || T.error);
            return fetch((ROUTES.root || '/') + 'cart.js', { headers: { Accept: 'application/json' } })
              .then(function (r) { return r.json(); })
              .then(function (cart) {
                updateCartCount(cart.item_count);
                var name = res.data.product_title || res.data.title || '';
                var variant = res.data.variant_title && res.data.variant_title !== 'Default Title'
                  ? ' · ' + res.data.variant_title : '';
                toast((T.added || 'Dodano') + ': ' + name + variant);
              });
          })
          .catch(function (err) { toast(err.message || T.error || 'Błąd'); })
          .then(function () {
            btn.disabled = false;
            btn.classList.remove('is-loading');
            if (label) label.textContent = original;
          });
      });
    });
  }

  /* ---------- 07 STRONA KOSZYKA: +/- i usuwanie ---------- */
  function initCartPage() {
    var form = qs('[data-cart-form]');
    if (!form) return;

    qsa('[data-qty-change]', form).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('[data-cart-item]');
        var input = qs('[data-qty-input]', item);
        if (!input) return;
        input.value = btn.getAttribute('data-qty-change');
        form.requestSubmit ? form.requestSubmit(qs('[name="update"]', form)) : form.submit();
      });
    });
  }

  /* ---------- 08 POJAWIANIE SIĘ SEKCJI ---------- */
  function initReveal() {
    var items = qsa('[data-reveal]');
    if (!items.length) return;

    if (!('IntersectionObserver' in window) ||
        window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      items.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.1 });

    items.forEach(function (el) { io.observe(el); });
  }

  /* ---------- START ---------- */
  function init() {
    initMenu();
    initCountdown();
    initFaq();
    initSizes();
    initGallery();
    initAddToCart();
    initCartPage();
    initReveal();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // Edytor motywu: przeładowanie sekcji bez odświeżania strony
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:block:select', function (e) {
    var el = e.target.closest('.acc__item');
    if (el) { el.classList.add('is-open'); qs('.acc__trigger', el).setAttribute('aria-expanded', 'true'); }
  });
})();
